import { render, staticRenderFns } from "./AddressCardComponent.vue?vue&type=template&id=3c44ab26"
import script from "./AddressCardComponent.vue?vue&type=script&lang=js"
export * from "./AddressCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports